import React from "react";

const List = ({ children }) => {
  return (
    <div className="strategy-video-row">{children}</div>
  );
};

export default List;
